module.exports = require("yargs");


//////////////////
// WEBPACK FOOTER
// external "yargs"
// module id = 52
// module chunks = 0